<div class="social mt-4">
    <div class="btn-showcase">
        <div class="row">
            <div *ngIf="isEmailLogin == 'false'" class="col-12" style="margin-bottom:10px">
                <a style="width: 100%; text-align: initial;" class="btn btn-light" (click)="loginMobile()">
                    <i class="fa fa-phone txt-linkedin" style="font-size: 17px; padding-left: 10px; padding-right: 10px;"></i>Continue with Mobile Number
                </a>
            </div>
            <div *ngIf="isEmailLogin == 'true'" class="col-12" style="margin-bottom:10px">
                <a style="width: 100%; text-align: initial;" class="btn btn-light" (click)="loginEmail()">
                    <i class="fa fa-envelope txt-linkedin" style="font-size: 17px; padding-left: 10px; padding-right: 10px;"></i>
                    Continue with Email
                </a>
            </div>
            <div class="col-12" style="margin-bottom:10px">
                <a style="width: 100%; text-align: initial;" class="btn btn-light" (click)="LinkedinLogin()">
                    <i class="fa fa-linkedin txt-linkedin" style="font-size: 17px; padding-left: 10px; padding-right: 10px;"></i>
                    Continue with LinkedIn
                </a>
            </div>
            <div class="col-12" style="margin-bottom:10px">
                <div id="buttonDiv"></div>
                <a style="width: 100%; text-align: initial;" class="btn btn-light" (click)="loginGoogle()">
                    <i class="fa fa-google txt-linkedin" style="font-size: 17px; padding-left: 10px; padding-right: 10px;"></i>
                    Continue with Google
                </a>
            </div>
            <div class="col-12" style="margin-bottom:10px; display:none">
                <a style="width: 100%; text-align: initial;" class="btn btn-light" (click)="loginFacebook()">
                    <i class="fa fa-facebook txt-linkedin" style="font-size: 17px; padding-left: 10px; padding-right: 10px;"></i>
                    Continue with Facebook
                </a>
            </div>
        </div>

    </div>
</div>
